const overflow = 'overflow' as const;

export const aliasOverflow = {
  overflow,
} as const;
